var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ProjectOverview" }, [
    _c(
      "div",
      {
        staticStyle: {
          height: "40px",
          display: "flex",
          "font-size": "18px",
          "font-weight": "bold",
          "align-items": "center",
          position: "relative",
        },
      },
      [
        _c(
          "div",
          { staticStyle: { "margin-right": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-back",
                  staticStyle: { "margin-right": "10px" },
                }),
                _vm._v(" 后退前页"),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticStyle: { color: "#000" } }, [
          _c(
            "span",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.$router.push(
                    "/ProjectInfo/ProjectAll?id=" + _vm.$route.query.id
                  )
                },
              },
            },
            [_vm._v(_vm._s(_vm.backName || "工作台"))]
          ),
          _c("i", { staticClass: "el-icon-arrow-right" }),
        ]),
        _c(
          "div",
          { staticClass: "ellipsis", staticStyle: { color: "#606266" } },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _c(
          "el-button",
          {
            staticClass: "exportpdf",
            attrs: { type: "primary", icon: "el-icon-download" },
            on: {
              click: function ($event) {
                return _vm.exportPDF()
              },
            },
          },
          [_vm._v("导出总览")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "centent" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "top-area",
        },
        [
          _c(
            "el-row",
            { staticClass: "wh100", attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-card", [
                    _c("div", { staticClass: "echarts-tit" }, [
                      _vm._v("提交率"),
                    ]),
                    _c("div", {
                      staticStyle: { width: "100%", height: "150px" },
                      attrs: { id: "DeviceProgress" },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-card", [
                    _c("div", { staticClass: "echarts-tit" }, [
                      _vm._v("通过率"),
                    ]),
                    _c("div", {
                      staticStyle: { width: "100%", height: "150px" },
                      attrs: { id: "DocumentProgress" },
                    }),
                  ]),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 16 } }, [
                _c(
                  "div",
                  { staticClass: "stats-grid" },
                  _vm._l(_vm.statsData, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "stat-item-wrapper" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "stat-card mini",
                            class: _vm.getStatCardClass(),
                          },
                          [
                            _c("div", { staticClass: "stat-item" }, [
                              _c("div", { staticClass: "stat-content" }, [
                                _c("div", { staticClass: "stat-label" }, [
                                  _vm._v(_vm._s(item.label)),
                                ]),
                                _c("div", { staticClass: "stat-value" }, [
                                  _vm._v(_vm._s(item.value)),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-area" },
        [
          _c(
            "el-card",
            [
              !_vm.isloadingPdf
                ? _c(
                    "el-button",
                    {
                      staticClass: "exportword",
                      attrs: { type: "primary", icon: "el-icon-download" },
                      on: { click: _vm.exportWord },
                    },
                    [_vm._v("导出数据")]
                  )
                : _vm._e(),
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                _vm._l(_vm.tabsData, function (item) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: item.value,
                      attrs: { label: item.name, name: item.value },
                    },
                    [
                      item.value === "总览" && _vm.activeName === "总览"
                        ? _c("Overview", {
                            ref: "Overview",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "设备统计" && _vm.activeName === "设备统计"
                        ? _c("DeviceView", {
                            ref: "DeviceView",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "供应商统计" &&
                      _vm.activeName === "供应商统计"
                        ? _c("SupplierView", {
                            ref: "SupplierView",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "设备清单" && _vm.activeName === "设备清单"
                        ? _c("DeviceInventoryList", {
                            ref: "DeviceInventoryList",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "设备资料清单" &&
                      _vm.activeName === "设备资料清单"
                        ? _c("DeviceDocumentList", {
                            ref: "DeviceDocumentList",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "备件清单" && _vm.activeName === "备件清单"
                        ? _c("SpareInventoryList", {
                            ref: "SpareInventoryList",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "资质清单" && _vm.activeName === "资质清单"
                        ? _c("CertificationInventoryList", {
                            ref: "CertificationInventoryList",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "项目资料清单" &&
                      _vm.activeName === "项目资料清单"
                        ? _c("ProjectInventoryList", {
                            ref: "ProjectInventoryList",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                      item.value === "供应商通讯录" &&
                      _vm.activeName === "供应商通讯录"
                        ? _c("SupplierInventoryList", {
                            ref: "SupplierInventoryList",
                            refInFor: true,
                            attrs: { pId: _vm.pId },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }